// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/js/chunks/" + chunkId + ".e3891242-da73-41c1-b906-40d50bfa5eda.js";
};